import { useMemo } from "react";

import { useQuery } from "@apollo/client";

import { RETRY_TRANSIENT } from "../../apollo/provider/createTransientRetryLink";
import { type ApolloResult } from "../../shared/models";
import { lensPayoutHistory } from "../api/queries/lensPayoutHistory";
import {
    type LensPayoutHistoryQuery,
    type LensPayoutHistoryQueryVariables,
} from "../api/queries/lensPayoutHistory.gql-generated";

interface UseLensPayoutHistoryParams {
    lensId: string;
}

interface LensPayoutHistoryResult {
    totalEarningsMilliUsd: number;
    lastPayoutDate: string | null;
}

export const useLensPayoutHistory = ({ lensId }: UseLensPayoutHistoryParams): ApolloResult<LensPayoutHistoryResult> => {
    const { data, loading, error } = useQuery<LensPayoutHistoryQuery, LensPayoutHistoryQueryVariables>(
        lensPayoutHistory,
        {
            skip: !lensId,
            variables: {
                lensId,
            },
            context: RETRY_TRANSIENT,
        },
    );

    return useMemo(() => {
        return {
            loading,
            error,
            totalEarningsMilliUsd: data?.lensPayoutHistory.totalEarningsMilliUsd ?? 0,
            lastPayoutDate: data?.lensPayoutHistory.lastPayoutDate ?? null,
        };
    }, [loading, error, data]);
};
